import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import React from "react";

export default class ServiceReportListGrid extends React.Component<any, any> {
    // Nicht editierbare Belege rot kennzeichnen
    handleDataBound = (e) => {
        var data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].IsNotEditable) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td:first", row);
                cell.css("background-color", "#ef5350");
                cell.css("color", "white");
            }

            if (data[i].IsReportedBackExternally) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td[data-field='StatusRText']", row);
                cell.css("background-color", "#558B2F");
                cell.css("color", "white");
            }

            if (data[i].ExternIncompleteData) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td[data-field='StatusRText']", row);
                cell.css("background-color", "#FF9800");
                cell.css("color", "white");
            }

            if (data[i].HasIncorrectData) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td[data-field='StatusRText']", row);
                cell.css("background-color", "#ef5350");
                cell.css("color", "white");
            }
        }
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.RELOAD) {
            this.props.context.onRefresh();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.props.context.onChangeServiceReportList(dataItem);         
        }
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: Helper.getTranslation("MonitorBaum.NeuLaden"), enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });

        return (
            <Grid
                id="serviceReportsList"
                data={this.props.context.serviceReportList.ServiceReports}
                options={this.props.context.serviceReportListGridOptions}
                onDataBound={this.handleDataBound}
                standardButtons={standardButtons}
                onClickStandardButton={this.handleClickStandardButton}>
            </Grid>
        );
    }
};
